"use client";
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box } from '@mui/material';
import Nav from './header';
import Footer from './footer';
import { NAVHEIGHT, pxToRem } from '@/util';
type props={
    children:React.ReactNode
}
export default function AppLayout({children}:props) {
    
    const {classes}=styles();
  return (
    <Box className={classes.container} >
     <Nav/>
     <Box className={classes.child}>
       {children}
     </Box>
     <Footer/>
    </Box>
  )
}

const styles=makeStyles()((theme)=>({
  container:{
    display:'flex',
    flexDirection:'column',
    height:'100%',
   
  },
  child:{
    minHeight:'400px',
    width:'100%',
    display:'flex',
    paddingTop:pxToRem(NAVHEIGHT),
    flex:1,
    flexDirection:'column',
    gap:theme.spacing(4)
  }
}))